import React from 'react'

import {
  theme,
  BreakpointIdentifier,
  mobileBreakpoints,
  tabletBreakpoints,
  desktopBreakpoints,
} from '@emico/styles'

import CurrentBreakpoint from './CurrentBreakpointContext'
import useWindowSize from './useWindowSize'

interface Props {
  children: React.ReactNode
}

const getCurrentBreakpoint = (windowWidth: number): BreakpointIdentifier => {
  const [identifier] = Object.entries(
    theme.breakpoints,
  ).reduce((breakpoint, [id, width]) =>
    windowWidth >= width ? [id, width] : breakpoint,
  )

  return identifier as BreakpointIdentifier
}

const BreakpointsProvider = ({ children }: Props) => {
  const [windowWidth, windowHeight] = useWindowSize()
  const currentBreakpoint = getCurrentBreakpoint(windowWidth)
  const isPortrait = windowWidth < windowHeight

  // Memoize so consumers only update when the breakpoint changes rather than
  // every time the windowWidth changes just slightly
  const value = React.useMemo(
    () => ({
      breakpoints: theme.breakpoints,
      currentBreakpoint,
      isMobile: mobileBreakpoints.includes(currentBreakpoint),
      isTablet: tabletBreakpoints.includes(currentBreakpoint),
      isDesktop: desktopBreakpoints.includes(currentBreakpoint),
      isPortrait: isPortrait,
    }),
    [currentBreakpoint, isPortrait],
  )

  return (
    <CurrentBreakpoint.Provider value={value}>
      {children}
    </CurrentBreakpoint.Provider>
  )
}

export default BreakpointsProvider
